import {FixedDataGrid, Data, Row} from "../../../lib/sbhtml/fixed-data-grid"
import {HelpButton} from "../../../lib/help button"
import * as React from "react"
import {ProrataPeriod, AnnualFormType, FinancialCodes} from "../common/types"
import {FieldCostItem} from "./types"
import {SectionHeading} from "../../../lib/sbhtml/heading"
import {Notification} from "../../../lib/sbhtml/notification"
import {Input} from "../../../lib/sbhtml/input"
import {ProrataPeriodInput} from "../common/presentation"
import * as strings from "../common/strings"

const headings = {
	Field: "Field",
	ProrataPeriod: "Pro-rata Period",
	GlCode: "Item Code",
	JobCode: "Job Code",
	AccountNumber: "Account Number",
}

type Fields = typeof headings
class CostItemFixedDataGrid extends FixedDataGrid<Fields>{}

export interface DataProps {
	fields: FieldCostItem[]
	annualCostInfoformField:number
	canProrata: boolean
}

export interface CallbackProps {
	onFieldProrataPeriodChange: (fieldCostItem: FieldCostItem, prorataPeriod: ProrataPeriod) => void
}

const renderCostItem = (props: FormFieldCostItemsProps) => (fieldCostItem: FieldCostItem): Row<keyof Fields> => {
	return {
		'Field': {
			node: <span>{fieldCostItem.field.label}</span>,
			alignment: "right",
			minWidth: "120px",
		},
		'ProrataPeriod': {
			minWidth: "100px",
			node: fieldCostItem.prorataPeriod == null ? null : (
				props.annualCostInfoformField == fieldCostItem.field.id
					? <div>
						{props.title} Cost{' '}
						<HelpButton message={strings.currentlyConfiguredViaStandardCostItem(props.title)} />
					</div>

					: <ProrataPeriodInput
						value={props.canProrata ? fieldCostItem.prorataPeriod : null}
						onChange={period => props.onFieldProrataPeriodChange(fieldCostItem, period)}
						name={`${props.formType}_field_${fieldCostItem.field.id}_prorata`}
					/>
			)
		},
		"GlCode": { node: <Input size="tiny" disabled={true} value={fieldCostItem.field.glCode} /> },
		"JobCode": { node: <Input size="tiny" disabled={true} value={fieldCostItem.field.jobCode} /> },
		"AccountNumber": { node: <Input size="tiny" disabled={true} value={fieldCostItem.field.accountNumber} /> }
	}
}

type FormFieldCostItemsProps = {
	formType: AnnualFormType
	title: string
	labels: FinancialCodes
} & CallbackProps & DataProps

const FormFieldCostItems = (props:FormFieldCostItemsProps) => {
	const myHeadings: Fields = {
		...headings,
		AccountNumber: props.labels.accountNumber,
		JobCode: props.labels.jobCode,
		GlCode: props.labels.glCode
	}

	const toShow = props.fields.length == 0
		? <Notification type="info">{strings.noFormFieldsWithPrices(props.formType)}</Notification>
		: <CostItemFixedDataGrid
			heading={myHeadings}
			data={props.fields.map(renderCostItem(props))}
		/>

	return <div>
		<SectionHeading title={`${props.title} Form Cost Items`} />
		{toShow}
	</div>
}

export type FieldCostItemProps = DataProps & CallbackProps & {labels: FinancialCodes}

export const SignupFieldCostItems = (props:FieldCostItemProps) =>
	<FormFieldCostItems title="Signup" {...props} formType="signup" />

export const RenewFieldCostItems = (props:FieldCostItemProps) =>
	<FormFieldCostItems title="Renewal" {...props} formType="renew" />



// WEBPACK FOOTER //
// ./src/membership3/pricing-option-form/field-items/presentation.tsx